import { graphql } from "react-relay";

/** Fields for CSK minimal-nav comment count chrome (utility fragment; spread at story query level). */
export const CskNavCommentCount_feedContentResource = graphql`
  fragment CskNavCommentCount_feedContentResource on FeedContentResourceInterface {
    title
    permalink
    resourceType
    authors {
      name
    }
    comments {
      enabled
      mode
    }
    chorusId
    chorusUuid
    globalId
    id
  }
`;
